<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="管理账号："
        prop="adminAccount">
        <el-input
          v-model="info.adminAccount"
          :disabled="!!info.sgsId"></el-input>
      </el-form-item>
      <el-form-item
        label="机构名称："
        prop="sgsName">
        <el-input v-model="info.sgsName"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人："
        prop="sgsPerson">
        <el-input v-model="info.sgsPerson"></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话："
        prop="sgsPhone">
        <el-input v-model="info.sgsPhone"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱："
        prop="sgsEmail">
        <el-input v-model="info.sgsEmail"></el-input>
      </el-form-item>
      <el-form-item
        label="省市："
        prop="area">
        <area-select v-model="info.area"></area-select>
      </el-form-item>
      <el-form-item
        label="机构地址："
        prop="sgsAddress">
        <el-input v-model="info.sgsAddress"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import AreaSelect from './area-select.vue'

export default {
  name: 'EditSgsModal',
  components: { AreaSelect },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        parentSgsId: null,
        sgsId: null,
        adminAccount: '',
        sgsName: '',
        sgsPerson: '',
        sgsPhone: '',
        sgsEmail: '',
        area: [],
        sgsAddress: ''
      },
      rules: {
        adminAccount: [
          { required: true, message: '请输入管理账号', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9]{4,18}$/, message: '管理账号长度 4-18 个字符,包括英文大小写和数字', trigger: 'blur' }
        ],
        sgsName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { max: 30, message: '机构名称长度最多 30 个字符', trigger: 'blur' }
        ],
        sgsPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { max: 15, message: '联系人长度最多 15 个字符', trigger: 'blur' }
        ],
        sgsPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[0-9][0-9]\d{8}$/,
            message: '请输入正确的联系电话',
            trigger: 'blur'
          }
        ],
        sgsEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择省市', trigger: 'blur' }
        ],
        sgsAddress: [
          { required: true, message: '请输入机构地址', trigger: 'blur' },
          { max: 50, message: '机构地址长度最多 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const sgsId = this.info.sgsId
      return (sgsId ? '编辑' : '新增') + '下属公司'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        parentSgsId: null,
        sgsId: null,
        adminAccount: '',
        sgsName: '',
        sgsPerson: '',
        sgsPhone: '',
        sgsEmail: '',
        area: [],
        sgsAddress: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.sgsId
            ? 'updatesgs'
            : 'addsgs'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              serviceProvinceCode: this.serviceProvinceCode,
              serviceCityCode: this.serviceCityCode
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(parentSgsId) {
      this.info.parentSgsId = parentSgsId
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
